import React, { useState, useEffect } from 'react';
import { InputField } from "../../components/form/input.field.component";
import { API_END_POINT } from "../../constants";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import ZoneModel from "../../models/masters/zone-model";
import * as Yup from "yup";
import { useGetUnions } from "../../apiclient/master/useGetUnionsApi"; // assuming this returns the list of unions
import { useGetZones } from '../../apiclient/master/useGetZoneApi'; // assuming this API fetches the existing zones

interface ZoneEditProps {
    data: ZoneModel;
    isViewMode?: boolean; // 
    onClose?: (status: SubmitStatus, data: any) => any;
}

const ZoneEntry: React.FC<ZoneEditProps> = ({ ...props }) => {
    let { data, onClose,isViewMode } = props;
    const title = data?.zoneId > 0 ? "Edit Zone" : "Add Zone";


    let initialValue: ZoneModel = {
        zoneId: data?.zoneId ? data.zoneId : 0,
        name: data?.name,
    };

    // Corrected validation schema for name
    const validationSchema = Yup.object().shape({
        name: Yup.string()
        .required("Required")
        .test("check-duplicate-name", " Zone name already exists", (value) => {
          // Ensure the value is compared in a case-insensitive manner
          return (
            value &&
            !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
            (data?.name && value === data.name) // Allow current name during update
          );
        }), 
    });
    console.log(initialValue)


    const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
    const { data: fetchedZone } = useGetZones(); // Fetching existing zones data

    useEffect(() => {
        if (fetchedZone) {
            setExistingName(fetchedZone.map((zone: any) => zone.name)); // Extracting zone names to compare against
        }
    }, [fetchedZone]);

    return (
        <>
            <FormikModelDialog
                width="50%"
                title={title}
                initialData={initialValue}
                validationSchema={validationSchema}
                show={!!data}
                onClose={onClose}
                endpoint={API_END_POINT.MASTER}
                showAddAnother={true}
                postRoute="Zone/SaveZone"
                isViewOnly ={isViewMode}
                isUpDateEntityDetails={data?.zoneId > 0 ? true : false}
            >
                <div>
                    <div className="row">
                        <div className="col-8">
                            <InputField maxLength={100} label="Zone *" name="name" />
                        </div>
                    </div>
                </div>
            </FormikModelDialog>
        </>
    );
};

export default ZoneEntry;
